import { Component, Input } from '@angular/core';
import { ActionCoPipeModel, Select } from '../../../models';
import { CoreService, HttpService } from '../../../services';
import { PipeCard } from '../../models/pipe-action-co.model';

@Component({
  selector: 'queoval-action-co-pipe-card',
  templateUrl: './action-co-pipe-card.component.html',
  styleUrls: ['../../pipe-formation/stage-pipe-card/stage-pipe-card.component.css','./action-co-pipe-card.component.css']
})
export class ActionCoPipeCardComponent {

  constructor(
    protected indParam: CoreService,
    protected http: HttpService,
  ) { }


  public card: PipeCard;
  public isMockUp: boolean = true;
  public model: ActionCoPipeModel = new ActionCoPipeModel();


  @Input() isPonderation: boolean;
  @Input('card')
  set _card(value: PipeCard) {
    if (value) {
      this.card = value;
      this.isMockUp = false;
    } else {
      this.isMockUp = true;
    }
  }

  public getCardInformation(card: any): any {
    const clientName: string = card.Client;
    const cloture: string = card.IsCloture ? ' cloturée' : '';
    const priorite: string = card.Priorite;
    let information: string = '';
  
    const selPriorite: Select | undefined = this.model.ListPriorites.find((prio: Select) => prio.id === priorite);
    if (selPriorite !== undefined && selPriorite.id !== '') {
      information = `${clientName} - Action commerciale${cloture} de priorité ${selPriorite.value} `;
    }
    else if (cloture !== '') {
      information = `${clientName}  - Action commerciale${cloture}`;;
    }
    else {
      information = clientName;
    }

    return information;
  }
}
